import { render, staticRenderFns } from "./MarginKpiGroup.vue?vue&type=template&id=cb47ff9a&"
import script from "./MarginKpiGroup.vue?vue&type=script&lang=js&"
export * from "./MarginKpiGroup.vue?vue&type=script&lang=js&"
import style0 from "./MarginKpiGroup.vue?vue&type=style&index=0&id=cb47ff9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports